import { Button, DatePicker, Modal } from 'antd';
import locale from 'antd/es/date-picker/locale/ko_KR';
import moment from 'moment';
import 'moment/locale/ko';
import React, { useEffect, useState } from 'react';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import * as XLSX from 'xlsx';
import { createOrderAsync } from '../../api/api';
import { httpPost, httpUrl } from '../../api/httpClient';
import { getUseNotifyOrderEtc } from '../../lib/module';
import {
  dosiguCodeReplace,
  getOrderStatusString,
  getOrderStatusStringm,
  orderStatusCode,
  paymentMethodString,
  pickupTimeValue,
  modalStyle, modalErrorStyle,
} from '../../lib/util/codeUtil';
import { comma } from '../../lib/util/numberUtil';
import DeliveryDetailModal from '../modal/DeliveryDetailModal';
import UpdateReregistModal from '../modal/UpdateReregistModal';
import { reactLocalStorage } from 'reactjs-localstorage';
import Const from '../../const';
import image from '../../res/image';

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const now = new Date();
const PagedListSize = 5;

const header = [
  {
    orderIdx: '주문번호',
    orderDate: '신청일시',
    completeDate: '완료일시',
    custAddr1: '도로명주소',
    custAddr3: '지번주소',
    orderPrice: '주문금액',
    deliveryPrice: '배달료',
    orderPayments: '결제수단',
    riderName: '기사명',
    riderPhone: '기사번호',
    orderStatus: '배송상태',
  },
];

const defDateType = {
  daily: 0,
  weekly: 1,
  monthly: 2,
  range: 3,
};

const defOrderStatusType = {
  all: 0,
  complete: 1,
  cancel: 2,
};

const CompleteList = (props) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 200,
    startDate: now,
    endDate: now,
    orderStatuses: [orderStatusCode.complete, orderStatusCode.cancel],
  });
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);

  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [updateReregistModalOpen, setUpdateReregistModalOpen] = useState(false);
  const [dateType, setDateType] = useState(defDateType.daily);
  const [orderStatusType, setOrderStatusType] = useState(
    defOrderStatusType.all
  );
  const [dialogData, setDialogData] = useState([]);
  const [isOpenRangePicker, setIsOpenRangePicker] = useState(false);
  const [deliverySum, setDeliverySum] = useState(0);
  const { delayPickupTime, basicPickupTime } =
    props.pickupTimeReducer.pickupTimeInfo;
  useEffect(() => {
    getListAsync();

    return () => {};
  }, [pagination]);

  const onChange = (page) => {
    setPagination({
      ...pagination,
      current: page,
    });
  };

  // const CountCompleted = () => {

  //   httpGet(httpUrl.countCompleted,
  //     [moment(this.state.selectedDate).format("YYYY-MM-DD")],
  //     {}
  //   )
  //     .then((res) => {
  //       setcountCompleted(res.data)
  //     })
  //     .catch((e) => {
  //       alert();
  //     })
  // };

  const getListAsync = async () => {
    if (
      moment(pagination.endDate).diff(moment(pagination.startDate), 'days') > 31
    ) {
      alert('기간을 한달 이내로 입력해주세요');
      return;
    }
    const pageSize = pagination.pageSize;
    const pageNum = pagination.current;
    const orderStatuses = pagination.orderStatuses;
    const startDate = moment(pagination.startDate).format(dateFormat);
    const endDate = moment(pagination.endDate)
      .add(1, 'days')
      .format(dateFormat);
    try {
      const res = await httpPost(httpUrl.orderCompleteList, [], {
        pageSize,
        pageNum,
        orderStatuses,
        startDate,
        endDate,
      });

      if (res.result !== 'SUCCESS') {
        setList([]);
        return;
      }

      setList(res.data.orders);
      setTotal(res.data.totalCount);
      setDeliverySum(res.data.deliverySum);
    } catch (e) {
      console.warn('getListAsync failed. ' + e);
    }
  };
  const onChangeDatePickerStart = (_, dateString) => {
    if (dateString) {
      if (new Date(pagination.endDate) - new Date(dateString) > 0) {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
        });
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: pagination.endDate,
          endDate: dateString,
        });
      }
      setDateType(defDateType.range);
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: now,
        endDate: now,
      });
      setDateType(defDateType.daily);
    }
  };

  const onChangeDatePickerEnd = (_, dateString) => {
    if (dateString) {
      if (new Date(pagination.startDate) - new Date(dateString) < 0) {
        setPagination({
          ...pagination,
          current: 1,
          endDate: dateString,
        });
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
          endDate: pagination.startDate,
        });
      }
      setDateType(defDateType.range);
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: now,
        endDate: now,
      });
      setDateType(defDateType.daily);
    }
  };

  const onChangeRangePicker = (dateString) => {
    const startDate = dateString[0];
    const endDate = dateString[1];

    setPagination({
      ...pagination,
      current: 1,
      startDate,
      endDate,
    });

    setDateType(defDateType.range);
    setIsOpenRangePicker(false);
  };

  const onOpenChangeRangePicker = (open) => {
    setIsOpenRangePicker(open);
  };

  const onChangeDateType = (dateType) => {
    let startDate, endDate;
    let isOpenRangePicker = false;

    switch (dateType) {
      case defDateType.daily:
        startDate = now;
        endDate = now;
        break;

      case defDateType.weekly:
        startDate = moment(now).add(-7, 'days');
        endDate = now;
        break;

      case defDateType.monthly:
        startDate = moment(now).add(-30, 'days');
        endDate = now;
        break;

      case defDateType.range:
        isOpenRangePicker = true;
        break;

      default:
        return;
    }

    setDateType(dateType);
    setIsOpenRangePicker(isOpenRangePicker);

    if (dateType !== defDateType.range) {
      setPagination({
        ...pagination,
        current: 1,
        startDate: startDate,
        endDate: endDate,
      });
    }
  };

  const onChangeOrderStatusType = (orderStatusType) => {
    let orderStatuses = [];
    switch (orderStatusType) {
      case defOrderStatusType.all:
        orderStatuses.push(orderStatusCode.complete, orderStatusCode.cancel);
        break;

      case defOrderStatusType.complete:
        orderStatuses.push(orderStatusCode.complete);
        break;

      case defOrderStatusType.cancel:
        orderStatuses.push(orderStatusCode.cancel);
        break;

      default:
        return;
    }

    setOrderStatusType(orderStatusType);
    setPagination({
      ...pagination,
      current: 1,
      orderStatuses,
    });
  };

  const orderReregist = (event, row) => {
    const newOrder = {
      ...row,
      orderDate: '',
      itemPrepared: false,
      ftOrderCode: null,
      bmOrderCode: null,
      userIdx: null,
    };
    // console.log(newOrder);
    const useEtcVoiceGuidance = getUseNotifyOrderEtc();

    Modal.confirm({
      title: '주문 재등록',
      content: '주문을 재등록하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      ...modalStyle,
      onOk() {
        createOrderAsync(newOrder).then((result) => {
          if (result === 'SUCCESS') {
            /*if (row.delayPickupTime === 0) {
              const pickupTimeIndex = pickupTimeValue.indexOf(
                row.arriveReqTime
              );
              if (pickupTimeIndex !== -1) {
                reactLocalStorage.setObject(
                  Const.appName + '#refPickupTime',
                  pickupTimeIndex
                );
              }
            }*/
            props.alert.show('배달정보를 접수하였습니다.');
          } else if (result === 'DELIVERY_NOT_ENABLED') {
            return;
          } else if (result === 'DELIVERY_START_DISABLED_AREA') {
            let message = '배달요청이 허용되지 않는 지역의 가맹점입니다.';
            Modal.error({
              title: '배달정보 재접수',
              content: <div>{message}</div>,
              ...modalErrorStyle,
              onOk() {},
            });
          } else if (result === 'DELIVERY_END_DISABLED_AREA') {
            let message = '배달요청이 허용되지 않는 주소입니다.';
            Modal.error({
              title: '배달정보 재접수',
              content: <div>{message}</div>,
              ...modalErrorStyle,
              onOk() {},
            });
          } else {
            if (
              result === 'NOT_ENOUGH_NCASH' ||
              result === 'NCASH_AUTO_CHARGE_FAIL'
            ) {
              props.alert.show(
                '예치금이 얼마 남지 않았습니다. 예치금을 충전해 주세요.'
              );
              if (useEtcVoiceGuidance) {
                let audio = new Audio('11.wav');
                audio.volume = this.props.posReducer.volume;
                audio.crossOrigin = 'anonymous';
                audio.play();
              }
            }
            Modal.error({
              title: '배달정보 재접수',
              content: (
                <div>
                  시스템에러로 배달요청에 실패하였습니다. 잠시 후 다시
                  시도해주세요.
                </div>
              ),
              ...modalErrorStyle,
              onOk() {},
            });
          }
        });
      },
    });
    event.stopPropagation();
  };

  // const updateReregist = (event,row) => {
  //   // <Link to ="/main"></Link>
  //   // console.log("ddd " + JSON.stringify(row,null,4));
  //   setDialogData(row);
  //   // console.log("qjsj " + JSON.stringify(dialogData,null,4));
  //   event.stopPropagation();
  // }

  const openDetailModal = (order) => {
    setSelectedRow(order);
    setDetailModalOpen(true);
  };

  const closeDetailModal = () => {
    setSelectedRow(null);
    setDetailModalOpen(false);
  };

  const openUpdateModal = (event, order) => {
    const newOrder = {
      ...order,
      ftOrderCode: null,
      bmOrderCode: null,
    };
    setSelectedRow(newOrder);
    setUpdateReregistModalOpen(true);
    event.stopPropagation();
  };

  const closeUpdateModal = () => {
    setUpdateReregistModalOpen(false);
    setSelectedRow(null);
  };

  const onDownload = async () => {
    if (
      moment(pagination.endDate).diff(moment(pagination.startDate), 'days') > 31
    ) {
      alert('기간을 한달 이내로 입력해주세요');
      return;
    }
    const pageNum = 1;
    const pageSize = 100000000;
    const orderStatuses = pagination.orderStatuses;
    const startDate = moment(pagination.startDate).format(dateFormat);
    const endDate = moment(pagination.endDate)
      .add(1, 'days')
      .format(dateFormat);
    const res = await httpPost(httpUrl.orderCompleteList, [], {
      pageSize,
      pageNum,
      orderStatuses,
      startDate,
      endDate,
    });
    if (res.result !== 'SUCCESS') {
      Modal.error({
        title: '엑셀 다운로드 오류',
        content: (
          <div>
            엑셀로 저장하는 동안 오류가 발생했습니다. 다시 시도해 주십시오.
          </div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    const title = '완료된배달';
    const filename = moment().format('YYYYMMDDhhmmss') + '_' + title + '.xlsx';

    const jsonData = res.data.orders.map((row) => ({
      orderIdx: row.idx,
      orderDate: moment(row.orderDate).format('YYYY-MM-DD HH:mm'),
      completeDate:
        row.completeDate && moment(row.completeDate).format('YYYY-MM-DD HH:mm'),
      custAddr1: row.destAddr1,
      custAddr3: row.destAddr3,
      orderPrice: row.orderPrice,
      deliveryPrice: row.deliveryPrice,
      orderPayments: row.orderPayments
        ? row.orderPayments.length === 0
          ? ''
          : row.orderPayments.length > 1
          ? '분할'
          : paymentMethodString[row.orderPayments[0].paymentMethod]
        : '',
      riderName: row.riderName,
      riderPhone: row.riderPhone,
      orderStatus: getOrderStatusString(row.orderStatus),
    }));

    const array = header.concat(jsonData);

    var ws = XLSX.utils.json_to_sheet(array, { skipHeader: true });
    var wb = XLSX.utils.book_new();

    ws['!cols'] = [];
    ws['!cols'][1] = { width: 20 };
    ws['!cols'][2] = { width: 20 };
    ws['!cols'][3] = { width: 40 };
    ws['!cols'][4] = { width: 40 };
    ws['!cols'][5] = { width: 17 };
    ws['!cols'][6] = { width: 17 };

    XLSX.utils.book_append_sheet(wb, ws, '완료된배달');
    XLSX.writeFile(wb, filename);
  };

  const skinType = Const.skinType.toUpperCase();

  return (
    <div className="delivery-element-complete">
      <DeliveryDetailModal
        data={selectedRow}
        isOpen={detailModalOpen}
        close={closeDetailModal}
      />
      {updateReregistModalOpen && (
        <UpdateReregistModal
          data={selectedRow}
          // isOpen={updateReregistModalOpen}
          close={closeUpdateModal}
        />
      )}
      <div className="delivery-element-menu">
        <div className="delivery-element-menu-all">
          <div
            className="delivery-element-card-btn-excel mobileoff"
            onClick={() => {}}
            style={{ paddingRight: '10px' }}>
            <Button className="excel-card" onClick={() => onDownload()}>
              엑셀&nbsp;
              <img
                style={{ display: 'inline' }}
                src={image.DownloadIcon}
                className="download-img"
                alt=""
              />
            </Button>
          </div>
          <div className="delivery-element-menu-text desk">진행상태</div>
          <div className="delivery-element-menu-text mobile">진행상태</div>
          <div className="delivery-element-menu-text complete-text1 pos">
            상태
          </div>
          <div
            className={orderStatusType === defOrderStatusType.all && skinType === "GOGOIT"
                ? 'gogoit-delivery-element-menu-text2 active'
                : orderStatusType === defOrderStatusType.all
                    ? 'delivery-element-menu-text2 active'
                    : 'delivery-element-menu-text2'
            }
            onClick={() => onChangeOrderStatusType(defOrderStatusType.all)}>
            전체
          </div>
          <div
            className={orderStatusType === defOrderStatusType.complete && skinType === "GOGOIT"
                ? 'gogoit-delivery-element-menu-text2 active'
                : orderStatusType === defOrderStatusType.complete
                    ? 'delivery-element-menu-text2 active'
                    : 'delivery-element-menu-text2'
            }
            onClick={() =>
              onChangeOrderStatusType(defOrderStatusType.complete)
            }>
            완료
          </div>
          <div
            className={orderStatusType === defOrderStatusType.cancel && skinType === "GOGOIT"
                ? 'gogoit-delivery-element-menu-text2 active'
                : orderStatusType === defOrderStatusType.cancel
                    ? 'delivery-element-menu-text2 active'
                    : 'delivery-element-menu-text2'
            }
            onClick={() => onChangeOrderStatusType(defOrderStatusType.cancel)}>
            취소
          </div>

          <div className="delivery-element-menu-2">
            <div className="delivery-element-menu-text">기간조회</div>
            <div
              className={dateType === defDateType.daily && skinType === "GOGOIT"
                  ? 'gogoit-delivery-element-menu-text2 active'
                  : dateType === defDateType.daily
                      ? 'delivery-element-menu-text2 active'
                      : 'delivery-element-menu-text2'
              }
              onClick={() => onChangeDateType(defDateType.daily)}>
              오늘
            </div>
            {/* <div
              className={
                "delivery-element-menu-text2" +
                (dateType === defDateType.weekly ? " active" : "")
              }
              onClick={() => onChangeDateType(defDateType.weekly)}
            >
              일주일
            </div> */}
            <div
              className={dateType === defDateType.monthly && skinType === "GOGOIT"
                  ? 'gogoit-delivery-element-menu-text2 active'
                  : dateType === defDateType.monthly
                      ? 'delivery-element-menu-text2 active'
                      : 'delivery-element-menu-text2'
              }
              onClick={() => onChangeDateType(defDateType.monthly)}>
              한달
            </div>
            <div
              className={dateType === defDateType.range && skinType === "GOGOIT"
                  ? 'gogoit-delivery-element-menu-text2 active2'
                  : dateType === defDateType.range
                      ? 'delivery-element-menu-text2 active2'
                      : 'delivery-element-menu-text2 del-menu-text2-sub'
              }
              onClick={() => onChangeDateType(defDateType.range)}>
              날짜지정
            </div>

            <div className="desk">
              <DatePicker
                placeholder={'시작일'}
                locale={locale}
                style={{
                  marginLeft: '10px',
                  height: '50px',
                  borderRadius: '10px',
                  marginTop: '-5px',
                  textAlign: 'center',
                }}
                size="large"
                format={dateFormat}
                value={moment(pagination.startDate, dateFormat)}
                onChange={onChangeDatePickerStart}
              />
              <DatePicker
                placeholder={'종료일'}
                locale={locale}
                style={{
                  // marginLeft: "10px",
                  height: '50px',
                  borderRadius: '10px',
                  marginTop: '-5px',
                  textAlign: 'center',
                }}
                size="large"
                format={dateFormat}
                value={moment(pagination.endDate, dateFormat)}
                onChange={onChangeDatePickerEnd}
              />
              {/* <RangePicker
                locale={locale}
                style={{
                  marginLeft: "10px",
                  height: "50px",
                  borderRadius: "10px",
                  marginTop: "-5px",
                  textAlign: "center",
                }}
                size="large"
                format={dateFormat}
                value={[
                  moment(pagination.startDate, dateFormat),
                  moment(pagination.endDate, dateFormat),
                ]}
                onChange={onChangeRangePicker}
                // open={isOpenRangePicker}
                onOpenChange={onOpenChangeRangePicker}
              /> */}
            </div>

            <div className="pos">
              <DatePicker
                placeholder={'시작일'}
                locale={locale}
                style={{
                  height: '40px',
                  borderRadius: '10px',
                  textAlign: 'center',
                }}
                size="small"
                format={dateFormat}
                value={moment(pagination.startDate, dateFormat)}
                onChange={onChangeDatePickerStart}
              />
              <DatePicker
                placeholder={'종료일'}
                locale={locale}
                style={{
                  // marginLeft: "10px",
                  height: '40px',
                  borderRadius: '10px',
                  textAlign: 'center',
                }}
                size="small"
                format={dateFormat}
                value={moment(pagination.endDate, dateFormat)}
                onChange={onChangeDatePickerEnd}
              />
              {/* <RangePicker
                locale={locale}
                style={{
                  marginLeft: "10px",
                  height: "40px",
                  borderRadius: "10px",
                  marginTop: "-5px",
                  textAlign: "center",
                }}
                size="middle"
                format={dateFormat}
                value={[
                  moment(pagination.startDate, dateFormat),
                  moment(pagination.endDate, dateFormat),
                ]}
                onChange={onChangeRangePicker}
                // open={isOpenRangePicker}
                onOpenChange={onOpenChangeRangePicker}
              /> */}
            </div>

            <div className="mobile">
              <DatePicker
                placeholder={'시작일'}
                locale={locale}
                style={{
                  height: '32px',
                  borderRadius: '6px',
                  marginTop: '5px',
                }}
                size="small"
                format={dateFormat}
                value={moment(pagination.startDate, dateFormat)}
                onChange={onChangeDatePickerStart}
              />
              <DatePicker
                placeholder={'종료일'}
                locale={locale}
                style={{
                  height: '32px',
                  borderRadius: '6px',
                  marginTop: '5px',
                }}
                size="small"
                format={dateFormat}
                value={moment(pagination.endDate, dateFormat)}
                onChange={onChangeDatePickerEnd}
              />
              {/* <RangePicker
                locale={locale}
                style={{ height: 32, borderRadius: "6px", marginTop: "5px" }}
                size="small"
                format={dateFormat}
                value={[
                  moment(pagination.startDate, dateFormat),
                  moment(pagination.endDate, dateFormat),
                ]}
                onChange={onChangeRangePicker}
                // open={isOpenRangePicker}
                onOpenChange={onOpenChangeRangePicker}
              /> */}
            </div>
          </div>
          <div className="delivery-complete-list desk">
            <div style={{ background: '#fff4ec' }}>
              총 : {comma(deliverySum)} 원
              <br />
              완료: {total} 건
            </div>
          </div>

          <div className="delivery-complete-list pos">
            <div style={{ background: '#fff4ec' }}>
              총 : {comma(deliverySum)} 원
              <br />
              완료: {total} 건
            </div>
          </div>
        </div>
      </div>

      <div className="delivery-element-complete-all">
        <div className="delivery-element-complete-block">
          <div className="delivery-element-complete-block-menu">
            <div className="delivery-element-complete-block-menu-text mobileoff">
              주문번호
            </div>
            <div className="delivery-element-complete-block-menu-text mobileoff">
              신청일시
            </div>
            <div className="delivery-element-complete-block-menu-text mobileoff">
              완료일시
            </div>
            <div className="delivery-element-complete-block-menu-text del-com3">
              고객정보
            </div>
            <div className="delivery-element-complete-block-menu-text del-com4">
              주문금액
              <div className="delivery-element-complete-block-menu-text-sub">
                (배달료)
              </div>
            </div>
            <div className="delivery-element-complete-block-menu-text mobileoff">
              결제수단
            </div>
            <div className="delivery-element-complete-block-menu-text mobileoff">
              기사정보
            </div>
            <div className="delivery-element-complete-block-menu-text ">
              배송
            </div>
            <div className="delivery-element-complete-block-menu-text mobileoff">
              재접수
            </div>
            <div className="delivery-element-complete-block-menu-text mobile">
              상세
            </div>
          </div>
        </div>
        <div className="completeList-wrapper">
          {(!list || list.length === 0) && (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              내역이 없습니다.
            </div>
          )}
          {list &&
            list.map((row, index) => (
              <div
                key={index}
                className={
                  'delivery-element-complete-block-field' +
                  (index % 2 === 0 ? '' : ' odd')
                }
                onClick={() => openDetailModal(row)}>
                <div className="delivery-element-complete-block-field-text mobileoff">
                  {row.idx}
                </div>
                <div className="delivery-element-complete-block-field-text mobileoff">
                  {moment(row.orderDate).format('YYYY-MM-DD HH:mm')}
                </div>
                <div className="delivery-element-complete-block-field-text mobileoff">
                  {row.completeDate &&
                    moment(row.completeDate).format('YYYY-MM-DD HH:mm')}
                </div>
                <div
                  style={{
                    fontSize: '1.1rem',
                    letterSpacing: (-1 / 20) * row.destAddr3.length,
                  }}
                  className="delivery-element-complete-block-field-text del-comsub3">
                  {`${
                    row.destAddr3
                      ? dosiguCodeReplace(row.destAddr3)
                      : dosiguCodeReplace(row.destAddr1)
                  } ${row.destAddr2}`}
                  {/* <div className="delivery-element-complete-block-field-text-sub">
                    {`${dosiguCodeReplace(row.destAddr1)} ${row.destAddr2}`}
                  </div> */}
                  {/* <div className="delivery-element-complete-block-field-text-sub">
                    {row.custPhone}
                  </div> */}
                </div>
                <div className="delivery-element-complete-block-field-text">
                  {comma(row.orderPrice)}원
                  <div className="delivery-element-block-field-text-sub">
                    ({comma(row.deliveryPrice)}원)
                  </div>
                </div>
                <div className="delivery-element-complete-block-field-text mobileoff">
                  {row.orderPayments
                    ? row.orderPayments.length === 0
                      ? ''
                      : row.orderPayments.length > 1
                      ? '분할'
                      : paymentMethodString[row.orderPayments[0].paymentMethod]
                    : ''}
                </div>
                <div className="delivery-element-complete-block-field-text mobileoff">
                  {row.riderName}
                  <div className="delivery-element-complete-block-field-text-sub mobileoff">
                    {row.riderPhone}
                  </div>
                </div>
                <div className="delivery-element-complete-block-field-text mobileoff">
                  <div
                    className={
                      row.orderStatus === orderStatusCode.cancel
                        ? 'delivery-element-complete-block2-field-text7'
                        : skinType === "GOGOIT"
                              ? 'gogoit-delivery-element-complete-block-field-text7'
                              : 'delivery-element-complete-block-field-text7'
                    }>
                    {getOrderStatusString(row.orderStatus)}
                  </div>
                </div>
                <div className="delivery-element-complete-block-field-text mobile">
                  <div
                    className={
                      row.orderStatus === orderStatusCode.cancel
                        ? 'delivery-element-complete-block2-field-text7'
                        : skinType === "GOGOIT"
                              ? 'gogoit-delivery-element-complete-block-field-text7'
                              : 'delivery-element-complete-block-field-text7'
                    }>
                    {getOrderStatusStringm(row.orderStatus)}
                  </div>
                </div>
                <div className="delivery-element-block-field-text mobileoff">
                  <Button
                    className="reRegist-btn"
                    onClick={(event) =>
                      orderReregist(event, { ...row, delayPickupTime })
                    }>
                    재접수
                  </Button>
                </div>
                <div className="delivery-element-block-field-text mobileoff">
                  {/* <Link
                  onClick={(event) => updateReregist(event,row)}
                  to = "/main"> */}
                  <Button
                    className="reRegist-btn"
                    onClick={(event) => {
                      openUpdateModal(event, row);
                    }}>
                    수정접수
                  </Button>
                  {/* </Link> */}
                </div>
                <div className="delivery-element-block-field-text mobile">
                  <Button className="del-btn">상세</Button>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* <div className="delivery-element-btn">
        <Pagination
          current={pagination.current}
          total={total}
          pageSize={pagination.pageSize}
          pagedListSize={PagedListSize}
          onChange={onChange}
        />
      </div> */}
      {/* <Route exact path="/Main" render={()=><Main order={dialogData}/>} /> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { posReducer, pickupTimeReducer } = state;
  return { posReducer, pickupTimeReducer };
};
const mapDispatchToProps = null;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAlert()(CompleteList));
